/** @format */

import React from 'react';
import SuperAgent from 'superagent';
import update from 'immutability-helper';

export default ComponentContainer => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                sending: false,
                sent: false,
                isLoggedIn: false,
                isSubmissionSuccessful: false,
                addressId: null,
                userId: null,
                formData: {},
                states: [],
                countries: []
            };
        }

        async componentDidMount() {
            const {
                body: {user}
            } = await SuperAgent.get('/account/users/current-user').set(
                'accept',
                'application/json'
            );
            let isLoggedIn = true;
            if (!user.id || user.is_guest === true) {
                isLoggedIn = false;
            }

            if (user.id) {
                this.setState({
                    userId: user.id,
                    formData: {company: user.company_entity.name}
                });
            }

            const {
                body: {states, countries}
            } = await SuperAgent.get('/account/addresses/states-and-countries').set(
                'Accept',
                'application/json'
            );
            this.setState({
                isLoggedIn,
                states,
                countries
            });
        }

        handleChange = updateTarget => this.setState(state => update(state, updateTarget));

        handleComment = event => {
            this.setState({comments: event.target.value});
        };

        handleSend = () => {
            this.setState({sending: true}, () => {
                SuperAgent.post('/legacy/contacts/simple-sample-pack')
                    .set('accept', 'application/json')
                    .send({
                        user_id: this.state.userId,
                        address: {...this.state.formData},
                        comments: this.state.formData.comments
                    })
                    .end((err, response) => {
                        this.setState({sent: true, sending: false});
                        if (err || !response.body) {
                            this.setState({
                                error: response.body ? response.body : err
                            });
                        } else {
                            if (typeof window.dataLayer !== 'undefined') {
                                window.dataLayer.push({
                                    event: 'samplePackRequest'
                                });
                            }

                            this.setState({
                                isSubmissionSuccessful: true
                            });
                        }
                    });
            });
        };

        handleLogin = () => {
            this.setState({isLoggedIn: true});
        };

        render() {
            const props = {...this.props};

            props.onHandleComments = this.handleComment;
            props.onSend = this.handleSend;
            props.onLogin = this.handleLogin;
            props.onChange = this.handleChange;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
};
